import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const months = ['janvier','fevrier','mars','avril','mai','juin','juillet','aout','septembre','octobre','novembre','decembre'];
  const [y, m, d] = dateStr.split('-');
  return `${parseInt(d)} ${months[parseInt(m) - 1]} ${y}`;
};

const getCountryFlag = (code) => {
  if (!code) return null;
  const lower = code.toLowerCase();
  return (
    <img
      src={`https://flagcdn.com/w40/${lower}.png`}
      srcSet={`https://flagcdn.com/w80/${lower}.png 2x`}
      alt={code}
      className="w-5 h-3.5 object-cover rounded-sm inline-block"
    />
  );
};

const CompletedTrips = () => {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrips = async () => {
      try {
        const response = await axios.get(`${API}/trips?status=completed`);
        const sorted = response.data.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        setTrips(sorted);
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };
    fetchTrips();
  }, []);

  return (
    <div data-testid="completed-trips-page">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#1E3A5F] to-[#2A4A6F] text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">NOS VOYAGES PASSES</h1>
          <p className="text-lg opacity-90">Retour sur les belles aventures que nous avons partagees</p>
        </div>
      </section>

      <section className="section">
        <div className="container-custom">
          {loading ? (
            <div className="flex justify-center py-12"><div className="spinner"></div></div>
          ) : trips.length === 0 ? (
            <div className="text-center py-20" data-testid="completed-trips-empty">
              <svg className="w-20 h-20 mx-auto text-[#79c9ea]/40 mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <h2 className="text-2xl font-bold text-[#1E3A5F] mb-3">Page en cours d'actualisation</h2>
              <p className="text-gray-500 text-base max-w-lg mx-auto mb-2">
                Nous preparons cette page pour vous faire revivre nos plus belles aventures passees.
              </p>
              <p className="text-gray-400 text-sm max-w-lg mx-auto mb-8">
                Bientot, vous retrouverez ici l'historique de nos voyages, des photos souvenirs
                et les temoignages de nos voyageurs. Revenez vite !
              </p>
              <Link to="/voyages" className="inline-block bg-[#5BC5D4] text-white px-6 py-2.5 rounded-lg font-bold hover:bg-[#4AB4C3] transition" data-testid="back-to-trips-btn">
                Decouvrir nos voyages actuels
              </Link>
            </div>
          ) : (
            <>
              <p className="text-center text-gray-600 mb-8">
                Depuis 1997, nous accompagnons nos voyageurs a travers le monde.
                Voici quelques-unes de nos destinations passees.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {trips.map((trip, index) => (
                  <div key={trip.id} className="card overflow-hidden opacity-90 hover:opacity-100 transition-opacity fade-in"
                    style={{ animationDelay: `${index * 0.1}s` }} data-testid={`completed-trip-${trip.id}`}>
                    <div className="relative h-48 overflow-hidden">
                      <img src={trip.image_url} alt={trip.destination} style={{ objectPosition: trip.image_focus ? `${trip.image_focus.x}% ${trip.image_focus.y}%` : 'center' }}
                        className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
                      <div className="absolute top-4 right-4">
                        <span className="bg-gray-700 text-white px-3 py-1 rounded-full text-sm font-semibold">Termine</span>
                      </div>
                      <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                        <h3 className="text-white text-xl font-bold">{trip.title}</h3>
                      </div>
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-2 mb-3">
                        <span className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-semibold">
                          {getCountryFlag(trip.country_code)}
                        </span>
                        <span className="text-sm text-gray-500">{trip.duration_days} jours</span>
                      </div>
                      <div className="text-sm text-gray-500 mb-3">
                        {formatDate(trip.start_date)} &rarr; {formatDate(trip.end_date)}
                      </div>
                      <p className="text-gray-600 text-sm line-clamp-2 mb-4">{trip.description}</p>
                      <div className="flex items-center justify-between">
                        <div className="leading-tight">
                          <div className="text-[10px] uppercase tracking-wide text-gray-400 font-semibold">Prix de base</div>
                          <div className="text-lg font-bold text-gray-400">{trip.price_from}&euro;</div>
                        </div>
                        <Link to={`/voyage/${trip.id}`} onClick={() => window.scrollTo(0, 0)}
                          className="text-[#5BC5D4] font-semibold text-sm hover:underline" data-testid={`view-completed-${trip.id}`}>
                          Voir le programme
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default CompletedTrips;
